/*
 * @description: 跟车人
 */
import type { FollowerConfigItem, IEmergencyContactInfo, INightServiceConf } from '@/pages/order-center/type';
import { useState, useCallback } from 'react';

export default function OrderCenterSameCityFollowerNum() {
  // 跟车人跟车人数(0不跟车 1人跟车 2人跟车)
  const [followerNum, setFollowerNum] = useState<number>(0);
  // 本人跟车标识 1：本人跟车 2：非本人跟车
  const [oneselfFollowFlag, setOneselfFollowFlag] = useState<number>(1);
  // 通知紧急联系人 1：通知  2：不通知 (默认)
  const [notifyEmergencyContact, setNotifyEmergencyContact] =
    useState<number>(2);
  // 紧急联系人手机号
  const [emergencyContactPhoneNo, setEmergencyContactPhoneNo] =
    useState<string>('');
  // 通知跟车人标识 1：通知 2：不通知
  const [notifyFollowerFlag, setNotifyFollowerFlag] = useState<number>(2);
  // 跟车人手机号
  const [followerTel, setFollowerTel] = useState<string>('');
  // 聚合接口 - 跟车配置
  const [followerConfig, setFollowerConfig] = useState<FollowerConfigItem[]>(
    []
  );

  // 紧急联系人信息、服务时间 每次进入页面都会拉取最新数据，无需在 set、reset 中处理
  // 紧急联系人信息
  const [emergencyContactInfo, setEmergencyContactInfo] =
    useState<IEmergencyContactInfo | null>(null);
  // 服务时间
  const [nightServiceConf, setNightServiceConf] =
    useState<INightServiceConf | null>(null);

  const reset = useCallback(() => {
    setFollowerNum(0);
    setOneselfFollowFlag(1);
    setEmergencyContactPhoneNo('');
    setNotifyEmergencyContact(2);
  }, []);

  const set = useCallback((val) => {
    setFollowerNum(val.followerNum);
    setOneselfFollowFlag(val.oneselfFollowFlag);
    setEmergencyContactPhoneNo(val.emergencyContactPhoneNo);
    setNotifyEmergencyContact(val.notifyEmergencyContact);
  }, []);

  return {
    followerNum,
    setFollowerNum,
    oneselfFollowFlag,
    setOneselfFollowFlag,
    notifyEmergencyContact,
    setNotifyEmergencyContact,
    emergencyContactPhoneNo,
    setEmergencyContactPhoneNo,
    notifyFollowerFlag,
    setNotifyFollowerFlag,
    followerTel,
    setFollowerTel,

    emergencyContactInfo,
    setEmergencyContactInfo,
    nightServiceConf,
    setNightServiceConf,

    followerConfig,
    setFollowerConfig,

    reset,
    set,
  };
}
